export function normalizeWorkerAvailableCreditsInput(raw: string): number | null {
  const trimmed = raw.trim();
  if (!trimmed) {
    return null;
  }
  const parsed = Number(trimmed);
  if (!Number.isFinite(parsed) || parsed < 0) {
    return null;
  }
  return parsed;
}

export function buildWorkerAvailableCreditsPatchBody(
  workerId: string,
  availableCredits: number,
): Record<string, unknown> {
  return {
    worker_id: workerId.trim(),
    remaining_credits: availableCredits,
    remainingCredits: availableCredits,
    available_credits: availableCredits,
  };
}

export function buildWorkerProfileImagePatchBody(
  workerId: string,
  profileImage: string,
): Record<string, unknown> {
  const trimmed = profileImage.trim();
  return {
    worker_id: workerId.trim(),
    profile_image: trimmed,
    profileImage: trimmed,
    picture: trimmed,
  };
}
